import React, { FC } from 'react'

import EmployerRateCardForm from 'syft-acp-core/entities/EmployerDetail/EmployerRateCardForm'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'
import { RouteComponentProps } from 'react-router-dom'

type Props = RouteComponentProps<{
  id: string
  rateCardID: string
}>

const NewEmployerRateCardView: FC<Props> = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <PageTitle title={[`Rate card ${params.rateCardID}`, recordLabel('Employer', params.id, employerName)]}>
      <div>
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        <EmployerRateCardForm id={Number(params.rateCardID)} employerId={Number(params.id)} />
      </div>
    </PageTitle>
  )
}

export default NewEmployerRateCardView
